// Resizes photos in the browser before upload: max 1600 px on the long
// side, re-encoded as WebP (JPEG where the browser can't encode WebP, e.g.
// Safari). Uploads stay small and fast on phones, and re-encoding drops
// EXIF data such as GPS location. The server still checks the file type.

const MAX_SIDE = 1600;
const QUALITY = 0.82;

async function decode(file) {
  if ('createImageBitmap' in window) {
    try { return await createImageBitmap(file, { imageOrientation: 'from-image' }); } catch { /* fall back */ }
  }
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.onload = () => resolve(img);
    img.onerror = () => reject(new Error('decode_failed'));
    img.src = URL.createObjectURL(file);
  });
}

const toBlob = (canvas, type) => new Promise((resolve) => canvas.toBlob(resolve, type, QUALITY));

export async function resizeImage(file, maxSide = MAX_SIDE) {
  const img = await decode(file);
  const w = img.width, h = img.height;
  const scale = Math.min(1, maxSide / Math.max(w, h));
  const canvas = document.createElement('canvas');
  canvas.width = Math.round(w * scale);
  canvas.height = Math.round(h * scale);
  const ctx = canvas.getContext('2d');
  ctx.imageSmoothingQuality = 'high';
  ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
  img.close?.();
  let blob = await toBlob(canvas, 'image/webp');
  if (!blob || blob.type !== 'image/webp') blob = await toBlob(canvas, 'image/jpeg');
  return blob;
}

export const ACCEPT_IMAGES = 'image/jpeg,image/png,image/webp';
